import { useState } from "react";
import { fetchStochasticCustomersCsv } from "@/api/fetchStochasticCustomers/fetchStochasticCustomersCsvApi";
import { downloadFile } from "@/utils/downloadFile";
import { FetchStochasticCustomersRequest } from "@/api/fetchStochasticCustomers/types";

export function useDownloadCustomersCsv() {
  const [loading, setLoading] = useState(false);

  const downloadCustomersCsv = (
    requestParams: FetchStochasticCustomersRequest,
  ) => {
    setLoading(true);
    fetchStochasticCustomersCsv(requestParams)
      .then((blob) => {
        const timestamp = new Date().toISOString().split("T")[0];
        const fileName = `customers-${timestamp}.csv`;
        downloadFile(blob, fileName);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    loading,
    downloadCustomersCsv,
  };
}
